// extracted by mini-css-extract-plugin
export default {"groupDescription":"AQYVs_KnyFLNjb9zt0_w","subGroups":"nxGa1h52ZN0gFL9fCAdt"};